import React, { PureComponent } from 'react';
import CostDisplay from './CostDisplay';

class ModifierContent extends PureComponent {
  render() {
    const { modifier } = this.props;
    return (
      <div className="simplePizzaModifierContent">
        {modifier.title}
        <CostDisplay cost={modifier.cost}/>
      </div>
    );
  }
}

export default ModifierContent;



// WEBPACK FOOTER //
// ./src/views/dashboard/components/items/components/PizzaCreatorModifiers/ModifierInput/ModifierContent.jsx